/* eslint-disable import/no-anonymous-default-export */
// eslint-disable-next-line import/no-anonymous-default-export
import secureLocalStorage from "react-secure-storage";
export default (message = { response: null }, action) => {
  switch (action.type) {
    case "SEND_APPROVER_VERIFICATION_CODE":
      return { ...message, response: action.payload };
    case "CHECK_APPROVER_VERIFICATION_CODE":
      secureLocalStorage.setItem("verify", JSON.stringify(action.data));
      return { ...message, response: action.payload };
    case "CHECK_APPROVER_VERIFICATION_CODE_ERROR":
      return { ...message, response: action.payload };
    default:
      return message;
  }
};
